@if (error) {
  <div class="error">
    {{ error }}
  </div>
}

@if (isLoading) {
  <preloader class="preloader" />
}

@if (!orders?.length) {
  <div class="no-orders">
    {{ 'account_orders.no_orders' | translate }}
  </div>
}

@for (order of orders; track order) {
  <div class="order" [class.order--expanded]="order.isExpanded">
    <div class="order__header">
      <div class="order__number">
        №{{ order.id }}
      </div>
      <time class="order__date">
        {{ order.createdAt | date:'medium' }}
      </time>
      <button class="order__expand"
        [class.order__expand--expanded]="order.isExpanded"
        (click)="order.isExpanded = !order.isExpanded"
        >
        <i class="mbi mbi-chevron-down"></i>
      </button>
    </div>
    @if (!order.isExpanded) {
      <div class="order__preview" (click)="order.isExpanded = !order.isExpanded">
        @for (item of order.items; track item) {
          <img class="order__img"
            [src]="uploadedHost + item.imageUrl"
            [alt]="item.name"
            loading="lazy"
            >
        }
      </div>
    }
    @if (order.isExpanded) {
      <div class="order__content">
        @for (item of order.items; track item) {
          <div class="order__item item">
            <img class="order__img item__img" [src]="uploadedHost + item.imageUrl" [alt]="item.name" loading="lazy">
            <div class="item__description">
              <a class="item__name main-link" [routerLink]="['/', item.slug]" target="_blank" routerLinkWithLang>
                {{ item.name }}
              </a>
              @if (item.additionalServices?.length) {
                <div class="item__additional-services">
                  @for (service of item.additionalServices; track service) {
                    <div class="item__additional-service">
                      {{ service.name }} (+{{ service.price }}{{ 'global.uah' | translate }})
                    </div>
                  }
                </div>
              }
              <div class="item__price-container">
                <div class="item__price">{{ item.price }} {{ 'global.uah' | translate }}</div>
                <div class="item__qty">{{ item.qty }} {{ 'global.pcs.' | translate }}</div>
                <div class="item__cost">{{ item.cost }} {{ 'global.uah' | translate }}</div>
              </div>
            </div>
          </div>
        }
        @if (isShippingMethodDelivery(order)) {
          <div class="order__info">
            <div class="order__info-label">
              {{ 'global.delivery' | translate }}:
            </div>
            <div class="order__info-value">
              {{ order.shipment.recipient.address.settlementNameFull || order.shipment.recipient.address.settlementName }}, {{ order.shipment.recipient.address.addressNameFull || order.shipment.recipient.address.addressName }}
              @if (order.shipment.recipient.address.buildingNumber; as buildingNumber) {
                <span>, {{ buildingNumber }}</span>
                }&nbsp;
                @if (order.shipment.recipient.address.flat; as flat) {
                  <span>, {{ flat }}</span>
                }
              </div>
            </div>
          }
          <div class="order__info">
            <div class="order__info-label">
              {{ 'global.shipment_method' | translate }}:
            </div>
            <div class="order__info-value">
              {{ order.shipment.shippingMethodDescription }}
            </div>
          </div>
          <div class="order__info">
            <div class="order__info-label">
              {{ 'global.payment' | translate }}:
            </div>
            <div class="order__info-value">
              {{ order.paymentMethodName }}
            </div>
          </div>
          @if (order.note; as note) {
            <div class="order__info">
              <div class="order__info-label">
                {{ 'account_orders.comment' | translate }}:
              </div>
              <div class="order__info-value">
                {{ note }}
              </div>
            </div>
          }
          <div class="order__info">
            <div class="order__info-label">
              {{ 'global.is_callback_needed' | translate }}
            </div>
            <div class="order__info-value">
              @switch (order.isCallbackNeeded) {
                @case (true) {
                  {{ 'global.yes' | translate }}
                }
                @case (false) {
                  {{ 'global.no' | translate }}
                }
              }
            </div>
          </div>
          @if (order.shipment.trackingNumber) {
            <div class="order__info">
              <div class="order__info-label">
                {{ 'account_orders.tracking_number' | translate }}:
              </div>
              <div class="order__info-value">
                {{ order.shipment.trackingNumber }}
              </div>
            </div>
          }
          @if (order.shipment.statusDescription) {
            <div class="order__info">
              <div class="order__info-label">
                {{ 'account_orders.tracking_status' | translate }}:
              </div>
              <div class="order__info-value">
                {{ order.shipment.statusDescription }}
              </div>
            </div>
          }
          @if (order.prices.discountValue; as discountValue) {
            <div class="order__info order__discount">
              {{ 'global.discount' | translate }}: {{ discountValue }} {{ 'global.uah' | translate }}
            </div>
          }
        </div>
      }
      <div class="order__footer">
        <div class="order__status">
          {{ order.status }}
        </div>
        <div class="order__price">
          {{ 'global.total_cost' | translate }}: {{ order.prices.totalCost }} {{ 'global.uah' | translate }}
        </div>
      </div>
    </div>
  }
